import { fbt } from 'fbtee'
import type { SetReportCategory, SetReportVerdict } from '../types'

export function setReportCategoryLabel(category: SetReportCategory): string {
  switch (category) {
    case 'times':
      return fbt('Set times', 'Set report category: the start or end time is wrong')
    case 'artist':
      return fbt('Artist', 'Set report category: wrong or missing artist, e.g. a B2B partner')
    case 'stage':
      return fbt('Stage', 'Set report category: the set is on the wrong stage')
    case 'image':
      return fbt('Artist photo', "Set report category: the artist's photo is wrong or low quality")
    case 'description':
      return fbt('Artist bio', "Set report category: the artist's bio is wrong or outdated")
    case 'other':
      return fbt('Something else', 'Set report category: free-text fallback')
  }
}

export function setReportVerdictLabel(verdict: SetReportVerdict): string {
  switch (verdict) {
    case 'confirmed':
      return fbt('Confirmed wrong', "The routine's verdict on a set report: the source shows it is wrong")
    case 'not-reproduced':
      return fbt('Source agrees with us', "The routine's verdict on a set report: the source matches our data")
    case 'unclear':
      return fbt("Couldn't verify", "The routine's verdict on a set report: no source settled it")
  }
}
